import React, { Component } from 'react'
import EmptySearchResults from './EmptySearchResults'
import { Table } from '@driftt/tide'
import { SearchResultsColumns } from 'constants/Table'
import RowFormatter from 'constants/Table/rowFormatter'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getSearchResults, getIsSearchPending } from 'modules/search/selectors'
import { setArticle, clearArticle } from 'modules/knowledgebase/actions'
import DeleteArticleContent from 'components/DeleteModalContent/DeleteArticleContent'

import './style.css'

class SearchResults extends Component {
  
  state = {
    isModalOpen: false
  }
  
  handleDeleteArticleClick = article => () => {
    const { actions } = this.props
    actions.setArticle(article)
    
    this.setState({isModalOpen: true})
  }
  
  handleCloseModal = () => {
    const { actions } = this.props
    this.setState({isModalOpen: false})
    actions.clearArticle()
  }
  
  buildSearchResults = () => {
    return this.props.searchResults.map(article => RowFormatter.SearchTableRows(article, this.handleDeleteArticleClick))
  }
  
  render() {
    const { searchResults, isSearchPending } = this.props
    const { isModalOpen } = this.state
    return (
      <div className="search-results-wrapper">
        <h2 className="search-results-text">
          {`Search Results: ${searchResults.length} Articles`}
        </h2>
        <Table
          columns={SearchResultsColumns}
          className="search-results-table"
          data={searchResults.length > 0 ? this.buildSearchResults() : []}
          isWorking={!!isSearchPending}
        />
        {isModalOpen &&
          <DeleteArticleContent
            isFromEditor={false}
            onCloseModal={this.handleCloseModal}
            isOpen={isModalOpen}
          />
        }
        {(searchResults.length === 0 && !isSearchPending) && <EmptySearchResults/>}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  searchResults: getSearchResults(state),
  isSearchPending: getIsSearchPending(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setArticle,
    clearArticle
  }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(SearchResults)